import React from 'react';

import './styles.css';

import { FaCheck, FaExclamation, FaDollarSign } from 'react-icons/fa';
import academyBillServices from '../../../../../services/academy/academyBillServices';

export default function InstallmentItem(props) {
    return (
        <li className={"installment-item-component" + (props.payed ? " green" : (props.isLate ? " red" : ""))}>
            {
                props.payed ?
                    <FaCheck />
                    :
                    props.isLate ?
                        <FaExclamation />
                        :
                        <FaDollarSign />
            }
            <div className='infos'>
                <p className='tittle'><b>
                    {`Parcela ${props.index + 1} - `}
                    {
                        props.payed ?
                            "Paga"
                            :
                            props.isLate ?
                                "Atrasada"
                                :
                                "Em aberto"
                    }
                </b></p>
                <p>
                    {
                        props.payed ?
                            `Pagamento: ${props.payDate.split('-').reverse().join('/')}`
                            :
                            `Vencimento: ${props.dueDate.split('-').reverse().join('/')}`
                    }
                </p>
                {
                    props.paymentMethod !== null ?
                        <p>Forma Pagamento: {academyBillServices.paymentMethods.find(obj => obj[0] === props.paymentMethod)[1]}</p>
                        :
                        null
                }
            </div>
            {
                props.payed ?
                <p><b>{props.paidValue}</b></p>
                :
                <p><b>{props.value}</b></p>
            }
        </li>
    )
}